import { getPaymentSandboxHeaders } from './helpers/getPaymentSandboxHeaders';
import { type Environment } from 'relay-runtime';
import { getEnvironment } from './helpers/relayModernEnvironment';

export function createCheckoutEnvironment({
    getGraphQLNetworkContext,
}: {
    getGraphQLNetworkContext?: () => string | null;
} = {}): Environment {
    return getEnvironment({
        getGraphQLNetworkContext,
        additionalHeaders: getPaymentSandboxHeaders(),
        storeOptions: {
            queryCacheExpirationTime: 1000 * 30, // 30 seconds
        },
    });
}
